import styled from '@emotion/styled';
import React from 'react';

const Block = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    height: 100%;
    width: 100%;

    z-index: 2;
    opacity: 0;
    animation: 0.3s linear 0s fadeIn;
    animation-fill-mode: forwards;

    background-color: rgba(255, 255, 255, 0.65);

    ${({ customCss }) => customCss};

    @keyframes fadeIn {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }
`;

const Ring = styled.div`
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 64px;
    height: 64px;
    margin: 8px;
    border: 8px solid ${({ theme }) => theme.colors.text.red};
    border-radius: 50%;
    animation: ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${({ theme }) => theme.colors.text.red} transparent
        transparent transparent;

    @keyframes ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

const SpinnerDiv = styled.div`
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
    transform: scale(${({ size }) => (size === 'small' ? '0.35' : '1')});

    ${Ring}:nth-of-type(1) {
        animation-delay: -0.45s;
    }
    ${Ring}:nth-of-type(2) {
        animation-delay: -0.3s;
    }
    ${Ring}:nth-of-type(3) {
        animation-delay: -0.15s;
    }
`;

const Spinner = ({ size = 'regular', customCss }) => {
    return (
        <Block {...{ customCss }}>
            <SpinnerDiv {...{ size }}>
                <Ring />
                <Ring />
                <Ring />
                <Ring />
            </SpinnerDiv>
        </Block>
    );
};

export default Spinner;
